import * as $ from 'jquery';
// import { Analytics } from '@plaudit/analytics';

export default class SmoothScroll {
	private smoothScrollEvent(event: JQueryEventObject): void {

		event.preventDefault();

		const anchor = <HTMLAnchorElement>event.currentTarget;

		$('html, body').animate(
			{ scrollTop: $('#' + anchor.hash.substr(1)).offset().top - event.data.offset },
			(event.data.duration || 1000),
			(event.data.easing || 'ease')
		);
	}
	public add(elements: string, data: Object): void {
		$(elements).on(<any>'click', data, this.smoothScrollEvent);
	}
}
